import { Operation } from '../../Transactions.types';
import { OperationDetailsContent } from '../OperationDetailsContent';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';

interface OperationDetailsBottomSheetProps {
  operation: Operation | null;
  onClose: () => void;
}

export function OperationDetailsBottomSheet({
  operation,
  onClose,
}: OperationDetailsBottomSheetProps) {
  return (
    <BottomSheet
      isOpen={!!operation}
      close={onClose}
      onCloseClick={onClose}
      isPageLocked
      isInPortal
      hasHeadBorder={false}
    >
      {operation ? (
        <OperationDetailsContent operation={operation} onClose={onClose} />
      ) : null}
    </BottomSheet>
  );
}
